import formValidators from '../../form-validators';
import { useForm } from '../../hooks/useForm.hook';
import { useResourceInput } from '../../hooks/useResourceInput';
import casetafelsService from '../../services/api/casetafels.service';
import Datepicker from '../forms/Datepicker';
import TextField from '../forms/TextField';

const DossierCasetafelDetails = ({
  dossierId,
  id,
  date,
  requestDescription,
  isCommission,
  read,
  readReportOnly,
  write,
  writeApproveAndQuestionnaireOnly,
  onUpdated
}) => {
  const { isSubmitting, data, reset, input, submitStart, submitOk, submitError } = useForm({
    id,
    date,
    requestDescription
  });

  const resource = {
    isFetching: false,
    isSubmitting,
    getValue: (field) => data?.[field],
    setValue: (value, field, options = {}) => {
      submitStart();
      casetafelsService.update(
        dossierId,
        data?.id,
        { [field]: value },
        {
          onSuccess: () => {
            submitOk();
            input(value, field);
            onUpdated(value, field, data?.id);
            options.onSuccess();
          },
          onError: (message) => {
            submitError({ [field]: message });
            options.onError(message);
          }
        }
      );
    },
    validators: {
      date: formValidators.date.nonRequiredDateField
    },
    onCancel: reset
  };
  const dateInput = useResourceInput('date', resource, '', { ignoreTouched: true });
  const requestDescriptionInput = useResourceInput('requestDescription', resource);

  if (!read) {
    return null;
  }

  return (
    <div className="spo-o-dossier-casetafel-details">
      <div className="row u-margin-bottom-lg">
        <div className="col-xs-12 col-md-6 col-lg-4 u-margin-bottom-xs">
          <Datepicker
            label={`Datum ${isCommission ? 'commissie' : 'casetafel'}`}
            {...dateInput}
            readOnly={!write || writeApproveAndQuestionnaireOnly}
          />
        </div>
        {!readReportOnly && (
          <div className="col-xs-12 u-margin-bottom-xs">
            <TextField
              label="Specifieke ondersteuningsvraag van de school"
              {...requestDescriptionInput}
              readOnly={!write}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DossierCasetafelDetails;
